/** Extrai `data` do envelope JSON da API (camelCase / PascalCase). */
export function unwrapApiEnvelopeData<T>(body: unknown, fallback: T): T {
  if (body === null || body === undefined || typeof body !== 'object') {
    return fallback;
  }
  const o = body as Record<string, unknown>;
  const raw = o['data'] ?? o['Data'];
  if (raw === undefined || raw === null) {
    return fallback;
  }
  return raw as T;
}
